<!-- @format -->

@if (!completionMethods || completionMethods.length === 0) {
  <div>
    <span translate="STUDIES.COURSE_UNIT_INFO_MODAL.NO_COMPLETION_METHODS"></span>
  </div>
}
@if (assessmentItemsById) {
  <div>
    @if (completionMethods?.length > 0) {
      <table class="sis-table table-completion-method-matrix" [attr.aria-label]="'COMPLETION_METHOD_MATRIX' | translate">
        <thead>
          <tr role="menu">
            @for (completionMethod of completionMethods; track completionMethod; let cmIndex = $index) {
              <th
                [class.is-highlighted]="highlightedCompletionMethod?.localId === completionMethod.localId"
                class="col-completion-method-matrix-completion-selection">
                <button type="button" class="non-button completion-method-container" (click)="highlightCompletionMethod(completionMethod)">
                  <span
                    [attr.aria-label]="
                      ('ARIA_LABEL.VIEW_COMPLETION_METHOD_INFO' | translate) +
                      ' ' +
                      ('STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD' | translate) +
                      ' ' +
                      (cmIndex + 1)
                    "
                    class="completion-method-header"
                    >{{ "STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD" | translate }} {{ cmIndex + 1 }}</span
                  >
                  <div>
                    <span class="tiny-badge secondary">
                      {{
                        "STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.STUDY_TYPE." +
                          (completionMethod.studyType === "OPEN_UNIVERSITY_STUDIES" ? "OPEN_UNIVERSITY_STUDIES" : "DEGREE_STUDIES")
                          | translate
                      }}
                    </span>
                  </div>
                  <span class="selected-method" [class.active]="selectedCompletionMethod?.localId === completionMethod.localId">
                    <span translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.SELECTED"></span>
                  </span>
                </button>
              </th>
            }
            <th class="completion-method-table-title">
              <h4 translate="STUDIES.COURSE_UNIT_INFO_MODAL.ASSESSMENT_ITEM_HEADER"></h4>
            </th>
            <th class="completion-method-table-title">
              <h4 translate="STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_REALISATIONS"></h4>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (assessmentItemId of orderedAssessmentItemIds; track assessmentItemId; let rowIndex = $index) {
            <tr
              [class.highlighted-completion-methods]="
                completionMethodContainsAssessmentItemId(highlightedCompletionMethod, assessmentItemId)
              "
              [class.is-selected]="isAssessmentItemSelectedForCourseUnit(assessmentItemId)"
              class="col-completion-method-matrix-assessment-item">
              @for (completionMethod of completionMethods; track completionMethod; let colIndex = $index) {
                <td
                  class="col-completion-method-matrix-completion-selection"
                  [class.is-highlighted]="highlightedCompletionMethod?.localId === completionMethod.localId">
                  @if (completionMethodContainsAssessmentItemId(completionMethod, assessmentItemId)) {
                    <div>
                      @if (completionMethod.typeOfRequire === "ALL_SELECTED_REQUIRED") {
                        <span>
                          @if (completionMethod.localId !== selectedCompletionMethod?.localId) {
                            <span>
                              <sis-icon icon="dot"></sis-icon>
                            </span>
                          }
                          @if (completionMethod.localId === selectedCompletionMethod?.localId) {
                            <span>
                              @if (isAssessmentItemSelectedInCompletionMethod(assessmentItemId, completionMethod)) {
                                <sis-icon icon="check"></sis-icon>
                              }
                              @if (!isAssessmentItemSelectedInCompletionMethod(assessmentItemId, completionMethod)) {
                                <span>
                                  <label class="control control-inline control-checkbox sis-checkbox">
                                    <input
                                      type="checkbox"
                                      [checked]="false"
                                      [disabled]="!canAssessmentItemBeSelected(assessmentItemId)"
                                      (click)="toggleAssessmentItemSelection(assessmentItemId, completionMethod)" />
                                    <div class="control-indicator"></div>
                                  </label>
                                </span>
                              }
                            </span>
                          }
                        </span>
                      }
                      @if (completionMethod.typeOfRequire !== "ALL_SELECTED_REQUIRED") {
                        <span>
                          <label
                            class="control control-inline control-checkbox sis-checkbox"
                            [class.disabled]="completionMethod.localId !== selectedCompletionMethod?.localId">
                            <input
                              type="checkbox"
                              [checked]="isAssessmentItemSelectedInCompletionMethod(assessmentItemId, completionMethod)"
                              [disabled]="
                                completionMethod.localId !== selectedCompletionMethod?.localId ||
                                !canAssessmentItemBeSelected(assessmentItemId)
                              "
                              (click)="toggleAssessmentItemSelection(assessmentItemId, completionMethod)" />
                            <div class="control-indicator"></div>
                          </label>
                        </span>
                      }
                    </div>
                  }
                </td>
              }
              <td class="assessment-items">
                {{ assessmentItemsById[assessmentItemId] | assessmentItemNameInCourseUnitContext: courseUnit | localizedString }}
                @if (!assessmentItemAttainmentsById[assessmentItemId]) {
                  <span> ({{ assessmentItemsById[assessmentItemId].credits | creditRange }}) </span>
                }
                @if (assessmentItemAttainmentsById[assessmentItemId]) {
                  <span>
                    ({{ assessmentItemAttainmentsById[assessmentItemId].credits }} <span translate="CREDITS"></span>)
                    <sis-icon icon="achievement"></sis-icon>
                    {{
                      assessmentItemAttainmentsById[assessmentItemId].gradeId
                        | grade: assessmentItemAttainmentsById[assessmentItemId].gradeScaleId
                        | async
                    }}
                  </span>
                }
                @if (
                  completionMethodContainsAssessmentItemId(selectedCompletionMethod, assessmentItemId) &&
                  !isAssessmentItemSelectedForCourseUnit(assessmentItemId) &&
                  !canAssessmentItemBeSelected(assessmentItemId)
                ) {
                  <span>
                    <br />
                    <sis-icon icon="alert" color="attention"></sis-icon>
                    <span
                      [translate]="'STUDIES.COURSE_UNIT_INFO_MODAL.ASSESSMENT_ITEM_ALREADY_SELECTED_UNDER_ANOTHER_COURSE_UNIT'"
                      [translateParams]="{
                        courseUnitName: getCourseUnitForAssessmentItem(assessmentItemId) | entityName | localizedString,
                      }"></span>
                  </span>
                }
              </td>
              <td class="course-unit-realisations">
                @if (courseUnitRealisationsReady) {
                  @for (
                    courseUnitRealisation of getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])
                      | slice: 0 : shownRelations;
                    track courseUnitRealisation
                  ) {
                    <span class="course-unit-realisations-list">
                      @if (completionMethodContainsAssessmentItemId(highlightedCompletionMethod, assessmentItemId)) {
                        <a href="javascript:void(0);" (click)="navigateToCurSection(courseUnitRealisation)">{{
                          courseUnitRealisation | courseUnitRealisationFullName | localizedString
                        }}</a>
                      }
                      @if (!completionMethodContainsAssessmentItemId(highlightedCompletionMethod, assessmentItemId)) {
                        <span>{{ courseUnitRealisation | courseUnitRealisationFullName | localizedString }}</span>
                      }
                      <sis-cur-flow-state-badge
                        [courseUnitRealisation]="courseUnitRealisation"
                        [hidePublishDate]="true"></sis-cur-flow-state-badge>
                    </span>
                  }
                  @if (getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])?.length === 0) {
                    <span class="guidance" translate="STUDIES.COURSE_UNIT_INFO_MODAL.NO_COURSE_UNIT_REALISATIONS"> </span>
                  }
                  @if (getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])?.length > shownRelations) {
                    <button
                      type="button"
                      class="link-button expand"
                      (click)="shownRelations = getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])?.length"
                      >{{ "STUDIES.COURSE_UNIT_INFO_MODAL.SHOW" | translate }}</button
                    >
                  }
                  @if (
                    getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])?.length === shownRelations &&
                    shownRelations > 5
                  ) {
                    <button type="button" class="link-button expand" (click)="shownRelations = 5">{{
                      "STUDIES.COURSE_UNIT_INFO_MODAL.HIDE" | translate
                    }}</button>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}
@if (assessmentItemsById && completionMethods && completionMethods.length > 0) {
  <div class="completion-method-info-container">
    <h2>
      <span
        translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD_LONG"
        [translateParams]="{ n: getHighlightedCompletionMethodIndex() + 1 }"></span>
      @if (highlightedCompletionMethod && selectedCompletionMethod?.localId === highlightedCompletionMethod.localId) {
        <span class="completion-method-selected">
          <sis-icon icon="check"></sis-icon>
          <span translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.SELECTED"></span>
        </span>
      }
    </h2>
    @if (highlightedCompletionMethod && selectedCompletionMethod?.localId !== highlightedCompletionMethod.localId) {
      <button
        type="button"
        class="btn btn-success btn-lg select-method"
        (click)="selectCompletionMethod(highlightedCompletionMethod)"
        translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.SELECT_CURRENT_COMPLETION_METHOD"></button>
    }
    @if (highlightedCompletionMethod?.typeOfRequire === "ALL_SELECTED_REQUIRED") {
      <div class="guidance-info">
        <h4 translate>STUDIES.COURSE_UNIT_INFO_MODAL.REQUIRE_RANGE_TITLE</h4>
        <span translate="STUDIES.COURSE_UNIT_INFO_MODAL.ALL_ASSESSMENT_ITEMS_REQUIRED"></span>
      </div>
    }
    @if (highlightedCompletionMethod?.typeOfRequire !== "ALL_SELECTED_REQUIRED") {
      <div class="guidance-info">
        @if (highlightedCompletionMethod?.typeOfRequire === "OPTIONAL_WITH_REQUIRE_RANGE") {
          <div>
            <h4 translate>STUDIES.COURSE_UNIT_INFO_MODAL.REQUIRE_RANGE_TITLE</h4>
            <div>{{ highlightedCompletionMethod?.require | intRange }}</div>
          </div>
        }
        @if (highlightedCompletionMethod?.assessmentItemOptionalityDescription) {
          <div>
            <h4 translate>STUDIES.COURSE_UNIT_INFO_MODAL.OPTIONALITY_DESCRIPTION_TITLE</h4>
            <sis-course-unit-info-modal-text-field
              [localizedMarkupStringValue]="highlightedCompletionMethod?.assessmentItemOptionalityDescription"
              [language]="language"></sis-course-unit-info-modal-text-field>
          </div>
        }
      </div>
    }
    @if (highlightedCompletionMethod) {
      <div class="row assessment-item-info">
        <div class="col-4 form-group-mimic">
          <h4 translate>STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.DESCRIPTION</h4>
          <sis-course-unit-info-modal-text-field
            [localizedMarkupStringValue]="highlightedCompletionMethod.description"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
        <div class="col-4 form-group-mimic">
          <h4 translate>STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.EVALUATION_CRITERIA</h4>
          <sis-course-unit-info-modal-text-field
            [localizedStringValue]="highlightedCompletionMethod.evaluationCriteria"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
        <div class="col-4 form-group-mimic">
          <h4 translate>STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.STUDY_PERIOD_REPEAT</h4>
          <sis-completion-method-repeats
            [completionMethod]="highlightedCompletionMethod"
            [language]="language"></sis-completion-method-repeats>
        </div>
      </div>
    }
    <h3 translate>STUDIES.COURSE_UNIT_INFO_MODAL.ASSESSMENT_ITEMS</h3>
    @if (completionMethodAssessmentItems && completionMethodAssessmentItems.length === 0) {
      <div class="form-group-mimic"> - </div>
    }
    @for (assessmentItem of completionMethodAssessmentItems; track assessmentItem) {
      <div>
        <sis-expandable
          [level]="4"
          [title]="
            (assessmentItem | assessmentItemNameInCourseUnitContext: courseUnit | localizedString) +
            ' ' +
            (assessmentItem.credits | creditRange)
          "
          [closed]="!isAssessmentItemExpandedById[assessmentItem.id]"
          (closedChange)="toggleAssessmentItem($event, assessmentItem.id)">
          <ng-template sisExpandableContent>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.NAME_SPECIFIER</h4>
                  <p class="form-control-static">{{ assessmentItem.nameSpecifier | localizedString }}</p>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.TYPE</h4>
                  <p class="form-control-static">{{ assessmentItem.assessmentItemType | codeLocalizedName | async }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.POSSIBLE_ATTAINMENT_LANGUAGES</h4>
                  @for (languageUrn of assessmentItem.possibleAttainmentLanguages; track languageUrn) {
                    <p class="form-control-static">
                      {{ languageUrn | codeLocalizedName | async }}
                    </p>
                  }
                  @if (assessmentItem.possibleAttainmentLanguages?.length === 0) {
                    <p class="form-control-static">-</p>
                  }
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FORMAT</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.studyFormat"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LEARNING_MATERIAL</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.learningMaterial"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LITERATURE</h4>
                  @for (literature of assessmentItem.literature; track literature) {
                    <sis-literature [literature]="literature" />
                  }
                  @if (assessmentItem.literature?.length === 0) {
                    <div>-</div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.CONTENT_DESCRIPTION</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.contentDescription"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.GRADING</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.grading"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group-mimic">
                  <h4 translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FIELD</h4>
                  <p class="form-control-static">{{ assessmentItem.studyField | codeLocalizedName | async }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 teacher">
                <div class="form-group-mimic">
                  <h4 translate="STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.RESPONSIBILITY_INFOS"></h4>
                  <sis-module-responsibility-info
                    [responsibilityInfos]="assessmentItem.responsibilityInfos"
                    [language]="language"></sis-module-responsibility-info>
                  @if (assessmentItem.responsibilityInfos?.length === 0) {
                    <p class="form-control-static">-</p>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <sis-responsible-organisation-info [organisations]="assessmentItem.organisations"></sis-responsible-organisation-info>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h3 translate>STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_REALISATIONS</h3>
                @for (courseUnitRealisation of getCourseUnitRealisationsForAssessmentItem(assessmentItem); track courseUnitRealisation) {
                  <div id="{{ courseUnitRealisation.id }}">
                    <sis-expandable
                      [variant]="'naked-dotted'"
                      [closed]="!isCourseUnitRealisationExpandedById[courseUnitRealisation.id]"
                      (closedChange)="toggleCourseUnitRealisation($event, courseUnitRealisation.id)"
                      [title]="courseUnitRealisation | courseUnitRealisationFullName | localizedString"
                      [level]="4">
                      <ng-template sisExpandableCustomTitle>
                        @if (courseUnitRealisation.flowState === "CANCELLED" || courseUnitRealisation.flowState === "ARCHIVED") {
                          <sis-tiny-badge variant="secondary">{{
                            "FLOW_STATE." + courseUnitRealisation.flowState | translate
                          }}</sis-tiny-badge>
                        }
                      </ng-template>
                      <ng-template sisExpandableContent>
                        <sis-course-unit-info-modal-course-unit-realisation
                          [courseUnitRealisation]="courseUnitRealisation"
                          [language]="language"></sis-course-unit-info-modal-course-unit-realisation>
                      </ng-template>
                    </sis-expandable>
                  </div>
                }
                @if (getCourseUnitRealisationsForAssessmentItem(assessmentItem)?.length === 0) {
                  <p class="guidance" translate="STUDIES.COURSE_UNIT_INFO_MODAL.NO_COURSE_UNIT_REALISATIONS"> </p>
                }
              </div>
            </div>
          </ng-template>
        </sis-expandable>
      </div>
    }
  </div>
}
